import React from "react";
import { Link } from "react-router-dom";
import { FaTimes } from "react-icons/fa";
import binaxpay from "../../assets/Image/binaxpay.png";
import Offcanvas from "bootstrap/js/dist/offcanvas";
import styles from "./css/Landingsidebar.module.css";
import Button from "../ui/Button";
import { useAuth } from "../../context/AuthContext";

const navItems = [
  "Home",
  "Features",
  "Benefits",
  "Pricing",
  "Testimonials",
  "Contact",
];

const LandingSidebar = ({ activeSection = "home" }) => {
  const {isAuthenticated} =  useAuth();
  const closeSidebar = () => {
    const el = document.getElementById("landingSidebar");
    if (el) {
      let instance = Offcanvas.getInstance(el);
      if (!instance) {
        instance = new Offcanvas(el);
      }
      instance.hide();
    }
  };

  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    closeSidebar();
    setTimeout(() => {
      const el = document.getElementById(targetId);
      if (el) {
        const topOffset = 85;
        const elementPosition = el.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - topOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    }, 250);
  };

  return (
    <div
      className={`offcanvas offcanvas-start ${styles.sidebarBox}`}
      tabIndex="-1"
      id="landingSidebar"
    >
      {/* Header with Logo and Close Button */}
      <div className={styles.sidebarHeader}>
        <Link to="/" onClick={(e) => handleNavClick(e, "home")}>
          <img src={binaxpay} alt="BinaXpay Logo" className={styles.sidebarLogo} />
        </Link>
      </div>

      {/* Nav Links */}
      <div className={styles.navContainer}>
        <ul className="nav flex-column">
          {navItems.map((item) => {
            const isActive = activeSection === item.toLowerCase();
            return (
              <li className="nav-item mb-1" key={item}>
                <a
                  href={`#${item.toLowerCase()}`}
                  className={`${styles.navLink} ${isActive ? styles.navLinkActive : ""}`}
                  onClick={(e) => handleNavClick(e, item.toLowerCase())}
                >
                  {item}
                </a>
              </li>
            );
          })}
        </ul>
      </div>

      {/* Bottom Action Buttons */}
      <div className={styles.footerSection}>
        {isAuthenticated ? (
          <>
            <div className={styles.footerTitle}>Welcome Back</div>
            <Button
              to="/dashboard"
              text="Go To Dashboard"
              className={styles.btnSignup}
              icon={<i className="fas fa-arrow-right"></i>}
              iconPosition="right"
              onClick={closeSidebar}
            />
          </>
        ) : (
          <>
            <div className={styles.footerTitle}>Get Started</div>
            <Button
              to="/Signin"
              text="Sign In"
              className={styles.btnSignin}
              onClick={closeSidebar}
            />
            <Button
              to="/Signup"
              text="Sign Up"
              className={styles.btnSignup}
              onClick={closeSidebar}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default LandingSidebar;